import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "../../../../services/axios";

export const getDeliveryZones = createAsyncThunk("sectiones/getDeliveryZones",async (args, thunkApi) => {
    try {
      const { data } = await axios.get("/Manage/Branches/LookDeliveryZone");
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response.data);
    }
  }
);


